const { ConnectFunction } = require('constants/reactRedux');
const { useEffect } = require('react');


/**
 * @description Custom HOOK to measure component's render time metrics.
 *
 * @param {React.Component} component Component whose performance to measure.
 *
 * @param {String} stackName Key for `Sephora.performance.stack` dictionary.
 */
const useRenderTimeMeasurements = (component, stackName) => {
    const startTime = performance.now();
    const oldStack = Sephora.performance.stack.current;
    let stack;

    if (stackName) {
        stack = Sephora.performance.stack.createNewNamedStack(stackName);
    } else {
        if (Sephora.performance.stack.current) {
            stack = Sephora.performance.stack.current;
        } else {
            stack = Sephora.performance.stack.createNewNamedStack(Symbol());
        }
    }

    let { componentName } = component;

    if (component.isComponent) {
        if (!componentName) {
            componentName = component.displayName;
        }
    } else {
        const isConnectHOC = !!(component.type?.name);

        if (isConnectHOC) {
            componentName = ConnectFunction;
        }
    }

    const context = {
        componentName,
        startTime
    };
    stack.push(context);
    const index = stack.length - 1;

    if (index > 0) {
        const parentContext = stack[index - 1];
        const renderFunctionTime = startTime - parentContext.startTime;
        Sephora.performance.renderTime.increaseHOCsRenderFunctionTime(parentContext.componentName, renderFunctionTime);
    }

    useEffect(() => {
        context.treeRenderTime = performance.now() - startTime;

        if (component.isComponent) {
            Sephora.performance.renderTime.increaseComponentRenderTime(componentName, context.treeRenderTime);
        } else {
            const childContext = stack[index + 1];

            if (childContext) {
                const renderTime = context.treeRenderTime - childContext.treeRenderTime;
                Sephora.performance.renderTime.increaseHOCsRenderTime(componentName, renderTime);
            } else {
                // HOC has rendered another component instead of `WrappedComponent` when `stackItem === null`.
                // TODO: Neeed to wrap all components with `ErrorBoundary` to enable support of this case.
                // As of now this scenario leads us to case when `context.treeRenderTime` contains not only HOC render time
                // but also includes component render time.
                // JIRRA:
                // We do not count this case untill JIRRA above is resolved!
            }
        }

        if (index === 0) {
            delete Sephora.performance.stack[stackName];
            Sephora.performance.stack.current = oldStack;
        }
    });
};

module.exports = { useRenderTimeMeasurements };
